(function () {
/* eslint-disable no-undef */ function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $197cd56b15c33885$var$COLUMNS_NUMBER = 4;
var $197cd56b15c33885$var$ROWS_NUMBER = 4;
var $197cd56b15c33885$var$board;
var $197cd56b15c33885$var$score = 0;
var $197cd56b15c33885$var$scoreBestItem = localStorage.getItem("scoreBest!!!") || 0;
var $197cd56b15c33885$var$startButton = document.querySelector(".start");
var $197cd56b15c33885$var$restartButton = document.querySelector(".restart");
var $197cd56b15c33885$var$scoreItem = document.querySelector(".game-score");
var $197cd56b15c33885$var$bestScoreItem = document.querySelector(".game-score-best");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
$197cd56b15c33885$var$startButton.addEventListener("click", $197cd56b15c33885$var$startGame);
$197cd56b15c33885$var$restartButton.addEventListener("click", $197cd56b15c33885$var$resetGame);
function $197cd56b15c33885$var$startGame() {
    $197cd56b15c33885$var$setGame();
    $197cd56b15c33885$var$startButton.classList.add("hidden");
    $197cd56b15c33885$var$restartButton.classList.remove("hidden");
    $197cd56b15c33885$var$messageStart.classList.add("hidden");
    $197cd56b15c33885$var$bestScoreItem.innerText = $197cd56b15c33885$var$scoreBestItem;
}
function $197cd56b15c33885$var$resetGame() {
    $197cd56b15c33885$var$resetBoard();
    $197cd56b15c33885$var$resetScore();
    $197cd56b15c33885$var$startButton.classList.remove("hidden");
    $197cd56b15c33885$var$restartButton.classList.add("hidden");
    $197cd56b15c33885$var$messageStart.classList.remove("hidden");
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$bestScoreItem.innerText = $197cd56b15c33885$var$scoreBestItem;
}
function $197cd56b15c33885$var$initializeBoard() {
    return Array.from({
        length: $197cd56b15c33885$var$ROWS_NUMBER
    }, function() {
        return Array($197cd56b15c33885$var$COLUMNS_NUMBER).fill(0);
    });
}
function $197cd56b15c33885$var$setGame() {
    $197cd56b15c33885$var$board = $197cd56b15c33885$var$initializeBoard();
    for(var i = 0; i < $197cd56b15c33885$var$ROWS_NUMBER; i++)for(var j = 0; j < $197cd56b15c33885$var$COLUMNS_NUMBER; j++){
        var fieldCell = document.createElement("div");
        fieldCell.id = i.toString() + "-" + j.toString();
        var num = $197cd56b15c33885$var$board[i][j];
        $197cd56b15c33885$var$updateTile(fieldCell, num);
        document.querySelector(".game-field").append(fieldCell);
    }
    $197cd56b15c33885$var$setNewElement();
    $197cd56b15c33885$var$setNewElement();
}
function $197cd56b15c33885$var$updateTile(fieldCell, num) {
    fieldCell.innerText = "";
    fieldCell.classList.value = "";
    fieldCell.classList.add("field-cell");
    if (num > 0) {
        fieldCell.innerText = num.toString();
        fieldCell.classList.add("field-cell--" + num.toString());
    }
    $197cd56b15c33885$var$gameWin();
}
function $197cd56b15c33885$var$resetScore() {
    $197cd56b15c33885$var$score = 0;
    $197cd56b15c33885$var$scoreItem.innerText = $197cd56b15c33885$var$score;
}
function $197cd56b15c33885$var$resetBoard() {
    var currentBoard = document.querySelector(".game-field");
    currentBoard.innerHTML = "";
}
function $197cd56b15c33885$var$hasEmptyTile() {
    for(var i = 0; i < $197cd56b15c33885$var$ROWS_NUMBER; i++)for(var j = 0; j < $197cd56b15c33885$var$COLUMNS_NUMBER; j++){
        if ($197cd56b15c33885$var$board[i][j] === 0) return true;
    }
    return false;
}
function $197cd56b15c33885$var$setNewElement() {
    var found = false;
    if (!$197cd56b15c33885$var$hasEmptyTile()) return;
    while(!found){
        var i = Math.floor(Math.random() * $197cd56b15c33885$var$ROWS_NUMBER);
        var j = Math.floor(Math.random() * $197cd56b15c33885$var$COLUMNS_NUMBER);
        if ($197cd56b15c33885$var$board[i][j] === 0) {
            var randomNum = Math.floor(Math.random() * 10);
            if (randomNum === 0) $197cd56b15c33885$var$board[i][j] = 4;
            else $197cd56b15c33885$var$board[i][j] = 2;
            var fieldCell = document.getElementById(i.toString() + "-" + j.toString());
            fieldCell.innerText = $197cd56b15c33885$var$board[i][j].toString();
            fieldCell.classList.add("field-cell--" + $197cd56b15c33885$var$board[i][j]);
            found = true;
        }
    }
    if ($197cd56b15c33885$var$gameOver()) $197cd56b15c33885$var$messageLose.classList.remove("hidden");
}
document.addEventListener("keyup", function(e) {
    var boardChanged = false;
    switch(e.code){
        case "ArrowLeft":
            boardChanged = $197cd56b15c33885$var$slideLeft();
            break;
        case "ArrowRight":
            boardChanged = $197cd56b15c33885$var$slideRight();
            break;
        case "ArrowUp":
            boardChanged = $197cd56b15c33885$var$slideUp();
            break;
        case "ArrowDown":
            boardChanged = $197cd56b15c33885$var$slideDown();
            break;
        default:
            alert("Please, use only arrows!");
    }
    if (boardChanged) {
        $197cd56b15c33885$var$setNewElement();
        $197cd56b15c33885$var$scoreItem.innerText = $197cd56b15c33885$var$score;
        if ($197cd56b15c33885$var$score >= $197cd56b15c33885$var$scoreBestItem) {
            $197cd56b15c33885$var$scoreBestItem = $197cd56b15c33885$var$score;
            $197cd56b15c33885$var$bestScoreItem.innerText = $197cd56b15c33885$var$score;
            localStorage.setItem("scoreBest!!!", $197cd56b15c33885$var$scoreBestItem);
        }
    }
});
function $197cd56b15c33885$var$deleteZero(row) {
    return row.filter(function(num) {
        return num !== 0;
    });
}
function $197cd56b15c33885$var$slide(originalRow) {
    var newRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(originalRow);
    newRow = $197cd56b15c33885$var$deleteZero(newRow);
    for(var i = 0; i < newRow.length - 1; i++)if (newRow[i] === newRow[i + 1]) {
        newRow[i] *= 2;
        newRow[i + 1] = 0;
        $197cd56b15c33885$var$score += newRow[i];
    }
    newRow = $197cd56b15c33885$var$deleteZero(newRow);
    while(newRow.length < $197cd56b15c33885$var$COLUMNS_NUMBER)newRow.push(0);
    return newRow;
}
function $197cd56b15c33885$var$slideLeft() {
    var _loop = function(i) {
        var row = $197cd56b15c33885$var$board[i];
        var originalRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        row = $197cd56b15c33885$var$slide(row);
        $197cd56b15c33885$var$board[i] = row;
        if (!boardChanged && !originalRow.every(function(val, index) {
            return val === row[index];
        })) boardChanged = true;
        for(var j = 0; j < $197cd56b15c33885$var$COLUMNS_NUMBER; j++){
            var fieldCell = document.getElementById(i.toString() + "-" + j.toString());
            var num = $197cd56b15c33885$var$board[i][j];
            $197cd56b15c33885$var$updateTile(fieldCell, num);
        }
    };
    var boardChanged = false;
    for(var i = 0; i < $197cd56b15c33885$var$ROWS_NUMBER; i++)_loop(i);
    return boardChanged;
}
function $197cd56b15c33885$var$slideRight() {
    var _loop = function(i) {
        var row = $197cd56b15c33885$var$board[i];
        var originalRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        row.reverse();
        row = $197cd56b15c33885$var$slide(row);
        row.reverse();
        $197cd56b15c33885$var$board[i] = row;
        if (!boardChanged && !originalRow.every(function(val, index) {
            return val === row[index];
        })) boardChanged = true;
        for(var j = 0; j < $197cd56b15c33885$var$COLUMNS_NUMBER; j++){
            var fieldCell = document.getElementById(i.toString() + "-" + j.toString());
            var num = $197cd56b15c33885$var$board[i][j];
            $197cd56b15c33885$var$updateTile(fieldCell, num);
        }
    };
    var boardChanged = false;
    for(var i = 0; i < $197cd56b15c33885$var$ROWS_NUMBER; i++)_loop(i);
    return boardChanged;
}
function $197cd56b15c33885$var$slideUp() {
    var _loop = function(j) {
        var row = [
            $197cd56b15c33885$var$board[0][j],
            $197cd56b15c33885$var$board[1][j],
            $197cd56b15c33885$var$board[2][j],
            $197cd56b15c33885$var$board[3][j]
        ];
        var originalRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        row = $197cd56b15c33885$var$slide(row);
        if (!boardChanged && !originalRow.every(function(val, index) {
            return val === row[index];
        })) boardChanged = true;
        for(var i = 0; i < $197cd56b15c33885$var$ROWS_NUMBER; i++){
            $197cd56b15c33885$var$board[i][j] = row[i];
            var fieldCell = document.getElementById(i.toString() + "-" + j.toString());
            var num = $197cd56b15c33885$var$board[i][j];
            $197cd56b15c33885$var$updateTile(fieldCell, num);
        }
    };
    var boardChanged = false;
    for(var j = 0; j < $197cd56b15c33885$var$COLUMNS_NUMBER; j++)_loop(j);
    return boardChanged;
}
function $197cd56b15c33885$var$slideDown() {
    var _loop = function(j) {
        var row = [
            $197cd56b15c33885$var$board[0][j],
            $197cd56b15c33885$var$board[1][j],
            $197cd56b15c33885$var$board[2][j],
            $197cd56b15c33885$var$board[3][j]
        ];
        var originalRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        row.reverse();
        row = $197cd56b15c33885$var$slide(row);
        row.reverse();
        if (!boardChanged && !originalRow.every(function(val, index) {
            return val === row[index];
        })) boardChanged = true;
        for(var i = 0; i < $197cd56b15c33885$var$ROWS_NUMBER; i++){
            $197cd56b15c33885$var$board[i][j] = row[i];
            var fieldCell = document.getElementById(i.toString() + "-" + j.toString());
            var num = $197cd56b15c33885$var$board[i][j];
            $197cd56b15c33885$var$updateTile(fieldCell, num);
        }
    };
    var boardChanged = false;
    for(var j = 0; j < $197cd56b15c33885$var$COLUMNS_NUMBER; j++)_loop(j);
    return boardChanged;
}
function $197cd56b15c33885$var$gameOver() {
    if ($197cd56b15c33885$var$hasEmptyTile()) return false;
    for(var i = 0; i < $197cd56b15c33885$var$ROWS_NUMBER; i++)for(var j = 0; j < $197cd56b15c33885$var$COLUMNS_NUMBER - 1; j++){
        if ($197cd56b15c33885$var$board[i][j] === $197cd56b15c33885$var$board[i][j + 1] || $197cd56b15c33885$var$board[j][i] === $197cd56b15c33885$var$board[j + 1][i]) return false;
    }
    return true;
}
function $197cd56b15c33885$var$gameWin() {
    for(var i = 0; i < $197cd56b15c33885$var$ROWS_NUMBER; i++){
        for(var j = 0; j < $197cd56b15c33885$var$COLUMNS_NUMBER; j++)if ($197cd56b15c33885$var$board[i][j] === 2048) {
            $197cd56b15c33885$var$messageWin.classList.remove("hidden");
            return true;
        }
    }
    return false;
}

})();
//# sourceMappingURL=index.fae3a0cd.js.map
